<div [hidden]="!chartData" id="weeklyBars"></div>
<mat-spinner *ngIf="!chartData"></mat-spinner>

